import { connect } from "react-redux";
import PreSalesSupply from "./preSalesSupply";
import { bindActionCreators } from "redux";
import {
  getDropDownValues,
  savePresalesSupply,
} from "services/redux/sales/preSalesSupply/action";
import { imageUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  dropDownList: state.getDropDownReducer.dropDownList,
  submitSuccess: state.getDropDownReducer.submitSuccess,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDropDownValues,
      savePresalesSupply,
      imageUploadUrl,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PreSalesSupply);
